import type {
  ShortVideo,
  ShortVideoBookmark,
  ShortVideoLike,
  ShortVideoSubscribe,
} from '@services/firebase/short-videos'

export function getFilteredShortVideos({
  selectedTopicIds,
  videos,
}: {
  readonly selectedTopicIds: string[]
  readonly videos: ShortVideo[]
}) {
  if (selectedTopicIds.length === 0) {
    return videos
  }

  return videos.filter(
    (video) => video.topicId && selectedTopicIds.includes(video.topicId),
  )
}

export function getCurrentVideoBookmark({
  bookmarks,
  userId,
  videoId,
}: {
  readonly bookmarks: ShortVideoBookmark[]
  readonly userId?: string
  readonly videoId: string
}) {
  if (!userId) {
    return null
  }

  return (
    bookmarks.find(
      (bookmark) => bookmark.authorId === userId && bookmark.videoId === videoId,
    ) ?? null
  )
}

export function getCurrentVideoSubscribe({
  channelId,
  subscribes,
  userId,
}: {
  readonly channelId?: string
  readonly subscribes: ShortVideoSubscribe[]
  readonly userId?: string
}) {
  if (!channelId || !userId) {
    return null
  }

  return (
    subscribes.find(
      (subscribe) =>
        subscribe.authorId === userId && subscribe.channelId === channelId,
    ) ?? null
  )
}

export function getShortVideoLikeCount({
  likes,
  videoId,
}: {
  readonly likes: ShortVideoLike[]
  readonly videoId: string
}) {
  return likes.filter((like) => like.videoId === videoId).length
}

export function hasUserLikedShortVideo({
  likes,
  userId,
  videoId,
}: {
  readonly likes: ShortVideoLike[]
  readonly userId?: string
  readonly videoId: string
}) {
  if (!userId) {
    return false
  }

  return likes.some((like) => like.authorId === userId && like.videoId === videoId)
}
